(function(){try{
  /* Case 28 - Christmas stocking purchase area. Loaded by theme.liquid on the seven stocking
     product pages only (handle guard). Two independent parts, both restyles of what the
     Globo Product Options app already rendered. The app's configuration is store level and
     is never touched from here.

     MIX & SAVE - Globo renders one <p> with <br> separated lines. CSS cannot lay <br> lines
     out as aligned rows, so we read that paragraph, find the lines containing an arrow (the
     tiers) and rebuild them as a list. The words are Globo's own, in whatever language Globo
     rendered them (Mix & Spar on /da/, Mix & Spare on /de/), so nothing here needs
     translating. If the paragraph stops matching - fewer than two arrow lines - it is left
     exactly as the app rendered it.

     THREAD SWATCHES - the Globo product-link radios link sibling PRODUCTS; there are no colour
     variants. Each radio value is the colour word from the sibling's product title, checked
     against the titles because two handles are misleading (...-tree-...-cranberry is Pine,
     ...-snowman-...-cranberry-copy is Marzipan). We render real links in place of the app's
     display:none radios, which could not take keyboard focus. A group is replaced only when
     every value is a known thread colour, so the Tree/Snowman design picker on the two
     un-personalised stockings is untouched. Colour names stay the same in every language
     (decision 2026-09-11). The heading comes from window.SagaI18n; fills live in the CSS.

     Globo renders late and may re-render, so apply() is idempotent and re-runs on a short
     poll and on DOM changes inside the purchase form. */
  var T=window.SagaI18n,R=window.SagaRoutes||{};
  if(!T)return;
  var NS='http://www.w3.org/2000/svg',ARROW=String.fromCharCode(8594);
  var THREADS={marzipan:1,pine:1,cinnamon:1,cranberry:1};

  function norm(s){s=String(s||'');[160,9,10,13].forEach(function(c){s=s.split(String.fromCharCode(c)).join(' ');});return s.replace(/ +/g,' ').trim();}
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}
  function root(){var r=R.root||(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';return r.slice(-1)==='/'?r:r+'/';}

  function sparkle(){
    var s=document.createElementNS(NS,'svg');s.setAttribute('viewBox','0 0 40 40');s.setAttribute('aria-hidden','true');s.setAttribute('focusable','false');
    var p=document.createElementNS(NS,'path');
    p.setAttribute('d','M20 3.5c.6 9.6 5.5 14.5 15.1 15.3-9.5.8-14.3 5.8-15.3 15.2-.6-9.4-5.4-14.1-14.8-14.9 9.4-1 14.2-5.9 15-15.6Z');
    p.setAttribute('fill','none');p.setAttribute('stroke','currentColor');p.setAttribute('stroke-width','3');p.setAttribute('stroke-linejoin','round');
    s.appendChild(p);return s;
  }

  function parseTiers(p){
    var parts=p.innerHTML.split(/<br[^>]*>/i),dp=new DOMParser(),title='',tiers=[],fine=[],seen=false,i;
    for(i=0;i<parts.length;i++){
      var s=norm(dp.parseFromString('<body>'+parts[i]+'</body>','text/html').body.textContent);
      if(!s)continue;
      var k=s.indexOf(ARROW);
      if(k>0){var a=norm(s.slice(0,k)),b=norm(s.slice(k+1));if(a&&b){tiers.push([a,b]);seen=true;continue;}}
      if(!seen)title=title?title+' '+s:s;else fine.push(s);
    }
    return (tiers.length>=2&&title)?{title:title,tiers:tiers,fine:fine}:null;
  }

  function mixSave(){
    var ps=document.querySelectorAll('.gpo-paragraph'),i,j;
    for(i=0;i<ps.length;i++){
      var p=ps[i],host=p.closest('.gpo-element')||p;
      if(host.classList.contains('saga-ms-src')||!host.parentNode)continue;
      var m=parseTiers(p);if(!m)continue;
      var box=el('div','saga-ms'),head=el('p','saga-ms__t'),list=el('ul','saga-ms__l');
      head.appendChild(sparkle());head.appendChild(document.createTextNode(m.title));box.appendChild(head);
      for(j=0;j<m.tiers.length;j++){
        var li=el('li');
        li.appendChild(el('span','saga-ms__q',m.tiers[j][0]));
        var dots=el('span','saga-ms__d');dots.setAttribute('aria-hidden','true');li.appendChild(dots);
        li.appendChild(el('span','saga-ms__p',m.tiers[j][1]));
        list.appendChild(li);
      }
      box.appendChild(list);
      if(m.fine.length){var f=el('p','saga-ms__f');for(j=0;j<m.fine.length;j++)f.appendChild(el('span',null,m.fine[j]));box.appendChild(f);}
      host.classList.add('saga-ms-src');
      host.parentNode.insertBefore(box,host.nextSibling);
    }
  }

  function swatches(){
    var groups=document.querySelectorAll('.gpo-pdLinks'),g,i;
    var path=location.pathname.split('/').filter(Boolean),here=path[path.length-1]||'';
    for(g=0;g<groups.length;g++){
      var grp=groups[g],host=grp.closest('.gpo-element')||grp;
      if(host.classList.contains('saga-sw-src')||!host.parentNode)continue;
      var radios=grp.querySelectorAll('input[data-type="product-link"]'),items=[],ok=radios.length>1,byPath=false;
      for(i=0;i<radios.length;i++){
        var r=radios[i],name=norm(r.value),key=name.toLowerCase(),h=r.getAttribute('data-product-handle')||'';
        if(!THREADS[key]||!h){ok=false;break;}
        if(h===here)byPath=true;
        items.push({name:name,key:key,handle:h,checked:r.checked});
      }
      if(!ok)continue;
      var id='saga-sw-t-'+g,box=el('div','saga-sw'),head=el('p','saga-sw__t',T.threadTitle||''),list=el('ul','saga-sw__g');
      head.id=id;box.setAttribute('role','group');box.setAttribute('aria-labelledby',id);box.appendChild(head);
      for(i=0;i<items.length;i++){
        var it=items[i],li=el('li'),a=el('a','saga-sw__a'),dot=el('span','saga-sw__c');
        a.href=root()+'products/'+encodeURIComponent(it.handle);
        if(byPath?it.handle===here:it.checked)a.setAttribute('aria-current','page');
        dot.setAttribute('data-color',it.key);dot.setAttribute('aria-hidden','true');
        a.appendChild(dot);a.appendChild(el('span','saga-sw__n',it.name));
        li.appendChild(a);list.appendChild(li);
      }
      box.appendChild(list);
      host.classList.add('saga-sw-src');
      host.parentNode.insertBefore(box,host.nextSibling);
    }
  }

  function apply(){try{mixSave();}catch(e){}try{swatches();}catch(e){}}
  apply();
  var n=0,iv=setInterval(function(){apply();if(++n>80)clearInterval(iv);},250);
  var form=document.querySelector('form.product-purchase-form');
  if(form&&window.MutationObserver){
    var pending=null;
    new MutationObserver(function(){if(pending)return;pending=setTimeout(function(){pending=null;apply();},60);}).observe(form,{childList:true,subtree:true});
  }
}catch(e){}})();
